import type { AnimationProps } from 'framer-motion';
import { motion } from 'framer-motion';
import type { CSS } from '@components-shared/src/stitches';
import { styled, theme } from '@components-shared/src/stitches';
import { heroTitleStyles } from '@components/basics/Hero/shared';

export const HeroContainer = styled('div', {
  display: 'flex',
  width: '100%',
  height: 390,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  overflow: 'hidden',
  transform: 'translate3d(0, 0, 0)',
  '@tablet': {
    height: 439,
  },

  '@laptop': {
    height: 540,
  },
});

export const HeroContent = styled('div', {
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  maxWidth: theme.widths.landingMaxWidth,
  marginTop: 20,

  '@tablet': {
    margin: '0 auto',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingX: 24,
    paddingY: 0,
  },

  variants: {
    showGoldenEggToggle: {
      true: {
        marginTop: 16,
        '@tablet': {
          marginTop: 'unset',
        },
      },
    },
  },
});

export const SongContainer = styled('div', {
  position: 'relative',
  zIndex: '$above2',
  borderRadius: 8,
  display: 'none',

  '@tablet': {
    display: 'block',
  },
});

export const SongInfo = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  color: 'white',
  gap: 4,
  width: '100%',
  base: 'S',

  '@tablet': {
    height: '100%',
    gap: 8,
    width: '100%',
    minWidth: 0,
    // account for golden egg tab
    paddingRight: 36,
  },

  '@tabletLandscape': {
    paddingRight: 0,
  },

  '.artistName': {
    whiteSpace: 'nowrap',
    width: 'max-content',
    base: 'S',
    fontStyle: 'medium',
    color: 'white',

    '@tablet': {
      base: 'L',
      color: '$neutral300',
    },
  },

  '.releaseTitle': {
    whiteSpace: 'nowrap',
    width: 'max-content',
    title: 'L',
    color: '$white',
    fontStyle: 'medium',
    '@tablet': {
      ...heroTitleStyles,
    },

    '@laptop': {
      title: 'XXL',
      color: '$white',
    },
  },
});

export const PlayContainer = styled('div', {
  position: 'absolute',
  bottom: '40%',

  '@tablet': {
    position: 'relative',
    bottom: 'unset',
  },
  '@desktop': {
    marginLeft: 'unset',
  },
});

export const PageContainer = styled('div', {
  position: 'relative',
  height: 394,
  display: 'flex',
  '@tablet': {
    display: 'none',
  },
});

export const fadeDown: AnimationProps = {
  initial: {
    opacity: 1,
    transform: 'translateY(0%)',
  },
  exit: {
    opacity: 0,
    transform: 'translateY(110%)',
  },
  transition: {
    delay: 0.1,
    duration: 0.5,
  },
};

export const textContainer: CSS = {
  width: 263,
  '@tablet': {
    width: 295,
  },

  '@laptop': {
    width: 500,
  },
};

export const textContainerWithLeftNav: CSS = {
  ...textContainer,
  '@laptop': {
    width: 346,
  },
  '@desktop': {
    width: 500,
  },
};

export const CountdownContainer = styled(motion.div, {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  '@tablet': {
    marginTop: 36,
    zIndex: '$above1',
    alignItems: 'flex-start',
    '> *:nth-child(1)': {
      alignItems: 'flex-start',
    },
  },
  variants: {
    small: {
      true: {
        gap: 24,
      },
    },
  },
});

export const WaveformContainer = styled('div', {
  position: 'absolute',
  bottom: 0,
  width: '100%',
});
